// @generated
// This file is automatically generated by Kanel. Do not modify manually.
import { harvestOperationId } from './HarvestOperation';
import { harvestOperationEventTypeEnum } from './HarvestOperationEventTypeEnum';
import { harvestOperationStatusEnum } from './HarvestOperationStatusEnum';
import { operatorId } from './Operator';
import { z } from 'zod';
export const harvestOperationEventId = (z.number());
export const harvestOperationEvent = z.object({
    id: harvestOperationEventId,
    harvest_operation_id: harvestOperationId,
    event_type: harvestOperationEventTypeEnum,
    occurred_at: z.date(),
    is_auto: z.boolean(),
    body: z.string().nullable(),
    is_incident: z.boolean(),
    status_from: harvestOperationStatusEnum.nullable(),
    status_to: harvestOperationStatusEnum.nullable(),
    created_at: z.date(),
    updated_at: z.date(),
    created_by: operatorId.nullable(),
    last_updated_by: operatorId.nullable(),
    deleted_at: z.date().nullable(),
    deleted_by: operatorId.nullable(),
});
export const harvestOperationEventInitializer = z.object({
    id: harvestOperationEventId.optional(),
    harvest_operation_id: harvestOperationId,
    event_type: harvestOperationEventTypeEnum,
    occurred_at: z.date(),
    is_auto: z.boolean().optional(),
    body: z.string().optional().nullable(),
    is_incident: z.boolean().optional(),
    status_from: harvestOperationStatusEnum.optional().nullable(),
    status_to: harvestOperationStatusEnum.optional().nullable(),
    created_at: z.date().optional(),
    updated_at: z.date().optional(),
    created_by: operatorId.optional().nullable(),
    last_updated_by: operatorId.optional().nullable(),
    deleted_at: z.date().optional().nullable(),
    deleted_by: operatorId.optional().nullable(),
});
export const harvestOperationEventMutator = z.object({
    id: harvestOperationEventId.optional(),
    harvest_operation_id: harvestOperationId.optional(),
    event_type: harvestOperationEventTypeEnum.optional(),
    occurred_at: z.date().optional(),
    is_auto: z.boolean().optional(),
    body: z.string().optional().nullable(),
    is_incident: z.boolean().optional(),
    status_from: harvestOperationStatusEnum.optional().nullable(),
    status_to: harvestOperationStatusEnum.optional().nullable(),
    created_at: z.date().optional(),
    updated_at: z.date().optional(),
    created_by: operatorId.optional().nullable(),
    last_updated_by: operatorId.optional().nullable(),
    deleted_at: z.date().optional().nullable(),
    deleted_by: operatorId.optional().nullable(),
});
//# sourceMappingURL=HarvestOperationEvent.js.map